const EDITABLE_ROLES = ['owner', 'admin', 'collaborator'];
const MANAGEMENT_ROLES = ['owner', 'admin'];

export const canEditAssetMetadata = (assetCanCollaborate?: boolean): boolean => {
  if (assetCanCollaborate !== undefined) {
    return assetCanCollaborate;
  }

  if (!BFG?.currentUser) return false;

  return (
    BFG.currentUser.su ||
    EDITABLE_ROLES.includes(BFG.currentUser.role)
  );
};

export const canManageAssets = (assetCanManage?: boolean): boolean => {
  // Prefer explicit backend-computed permission if provided
  if (assetCanManage !== undefined) {
    return assetCanManage;
  }

  if (!BFG?.currentUser) return false;

  return (
    BFG.currentUser.su ||
    MANAGEMENT_ROLES.includes(BFG.currentUser.role)
  );
};

export const canViewAsset = (): boolean => {
  return Boolean(BFG?.currentUser);
};

export const getCurrentUserPermissions = () => {
  return {
    canView: canViewAsset(),
    canEdit: canEditAssetMetadata(),
    canManage: canManageAssets(),
  };
};
